import { FC } from 'react'
import { Outlet } from 'react-router-dom'
import { useNotifications } from '../../hooks/useNotifications'
import { Wrapper } from '../Wrapper'

export const MainLayout: FC = () => {
    useNotifications()

    return (
        <Wrapper>
            <Outlet />
        </Wrapper>
    )
}
